<template>
	<v-modal>
		<template v-slot:header>
			<h1 v-if="!openedPortal">Your Search Pack Is Ready To Order</h1>
			<h1 v-if="openedPortal">Confirm Search Pack Order Details</h1>
		</template>
		<div v-if="!openedPortal">
			<section class="alert alert--info">
				<p>Don't forget, you will need to return here to update your search pack order reference once you have completed the order.</p>
			</section>
		</div>
		<form v-if="openedPortal" @submit.prevent>
			<fieldset>
				<div>
					<label><span>Order Reference Number </span>
						<input v-model="form.data.provider_id" type="text">
					</label>
					<div class="alert-block alert-block--below">
						<section class="alert alert--info editorial">
							<header>
								<div>
									<h1 class="alpha">Did you know we offer a fully managed search pack service?</h1>
								</div>
							</header>
							<div>
								<div>
									<ul class="benefit-list">
										<li>No redirects to other portals</li>
										<li>Monitor order progress with expected completion date</li>
										<li>View search pack documents right from your calm dashboard</li>
									</ul>
									<p class="beta">Contact the Calm team to find out more!</p>
								</div>
							</div>
						</section>
					</div>
				</div>
			</fieldset>
		</form>
		<template v-slot:footer>
			<ul class="actions">
				<li>
					<button class="button button--secondary" @click.prevent="close">Cancel</button>
				</li>
				<li v-if="!openedPortal">
					<button
						class="button button--primary" @click="redirectToPortal">Continue To Portal
					</button>
				</li>
				<li v-if="openedPortal">
					<process-button
						:processing="form.processing" class="button button--primary" text="Update Order Details"
						@click="submit"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	data() {
		return {
			openedPortal: false,
			form: this.newForm({
				provider_id: "",
			}),
		};
	},

	props: {
		redirect: {
			required: true,
			type: String,
		},
		searchPack: {
			required: true,
			type: Object,
		},
	},

	methods: {
		close() {
			this.$vmodal.close();
		},
		redirectToPortal() {
			window.open(this.redirect, "_blank");
			this.openedPortal = true;
		},
		submit() {
			this.form.patch(this.route("search-packs/:searchPack/update-reference", this.searchPack)).then(response => {
				this.$store.dispatch("alertsStore/success", "Search Pack Updated");
				this.$router.push({name: "searchPacks.index"});
			});
		},
	},
};
</script>
